import React, { memo, useRef, useState } from 'react'
import { ColorPicker } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import type { CustomCellEditorProps } from 'ag-grid-react'
import type { Color } from 'antd/es/color-picker'
import { ColorSwatch } from '../cellRenderers/CellComponents'
import './ColorPickerEditor.css'

/**
 * Custom Color Picker Cell Editor using Ant Design ColorPicker
 *
 * Provides a color picker editor for AG Grid cells
 * Stores colors as hex strings (e.g., "#FF0000")
 */
const ColorPickerEditor = memo(({ value, onValueChange, stopEditing }: CustomCellEditorProps<any, string>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [color, setColor] = useState<string>(value || '#000000')
  const [open, setOpen] = useState(true)

  const handleChange = (newColor: Color) => {
    const hexValue = newColor.toHexString()
    setColor(hexValue)
    onValueChange(hexValue)
  }

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen)
    if (!isOpen) {
      stopEditing()
    }
  }

  return (
    <div ref={containerRef} className="color-picker-cell-editor">
      <ColorPicker
        getPopupContainer={() => document.body}
        value={color}
        open={open}
        onChange={handleChange}
        onOpenChange={handleOpenChange}
        showText={() => (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <ColorSwatch color={color} />
            <DownOutlined style={{ fontSize: 10, opacity: 0.45, flexShrink: 0 }} />
          </div>
        )}
      />
    </div>
  )
})

ColorPickerEditor.displayName = 'ColorPickerEditor'

export default ColorPickerEditor
